import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useTheme } from '../context/ThemeContext';

// CssBaseline intentionally removed — it was applying the MUI dark theme's
// background-color to <body>, causing pages to fade to dark via CSS transition.
// Body background is controlled by index.css + data-theme attribute instead.
const MuiThemeWrapper = ({ children }) => {
  const { currentTheme } = useTheme();

  return (
    <MuiThemeProvider theme={currentTheme.mui}>
      {children}
    </MuiThemeProvider>
  );
};

export default MuiThemeWrapper;
